import { React, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { usersAtom, isLoginAtom } from "./atoms";
import { useSetRecoilState } from "recoil";

import Header from "./shareComponets/header";
import Footer from "./shareComponets/footer";
import AModal from "./shareComponets/amodal";

import Home from "./components/Home";
import Board from "./components/routes/Board.js";
import Board2 from "./components/routes/Board2.js";
import NotFound from "./shareComponets/error/notfound";

function App() {
  const setUsers = useSetRecoilState(usersAtom);
  const islogin = useSetRecoilState(isLoginAtom);
  /*
  function setScreenSize() {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);
  }*/
  useEffect(() => {
    //setScreenSize();
    const saved = localStorage.getItem("id");
    if (saved !== null) {
      setUsers(saved);
      islogin(true);
    }
  });

  return (
    <div style={{ minHeight: "100vh" }}>
      <Router>
        <AModal />
        <Header />
        <div
          className="container-fluid d-flex flex-column"
          style={{ minHeight: "85vh" }}
        >
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/board" element={<Board />} />
            <Route path="/board2" element={<Board2 />} />
            <Route path="*" element={<NotFound />}></Route>
          </Routes>
        </div>
        <Footer />
      </Router>
    </div>
  );
}

export default App;
